import { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { Sponsors } from './Sponsors';
import { fadeInUp } from '../../lib/animations';
import { staggerContainer } from '../../lib/animations';
import { useLanguage } from '../../context/LanguageContext';

export const Gallery = () => {
  const { t } = useLanguage();
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  const images = [
    'https://customer-assets-rejwkqb3.emergentagent.net/job_padel-arena-modern/artifacts/gifcfzdk_DSC06849.webp',
    'https://customer-assets-rejwkqb3.emergentagent.net/job_padel-arena-modern/artifacts/y98iksol_DSC06846.webp',
    'https://customer-assets-rejwkqb3.emergentagent.net/job_padel-arena-modern/artifacts/8xrzoyud_DSC06837%20%281%29.webp',
    'https://customer-assets-rejwkqb3.emergentagent.net/job_padel-arena-modern/artifacts/aqs0h1ck_DSC06840.webp',
    'https://customer-assets-rejwkqb3.emergentagent.net/job_padel-arena-modern/artifacts/nj8h18ke_DSC06837.webp',
    'https://customer-assets.emergentagent.com/job_padel-arena-modern/artifacts/vqamn5j5_DSC07851.jpg'
  ];

  return (
    <section id="gallery" ref={ref} className="py-32 bg-white" data-testid="gallery-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
          className="text-center max-w-3xl mx-auto mb-20"
        >
          <p className="overline mb-4">{t.gallery.label}</p>
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-slate-900 mb-6 tracking-tight">
            {t.gallery.title}
          </h2>
          <p className="text-xl text-slate-600">
            {t.gallery.subtitle}
          </p>
        </motion.div>

        <motion.div 
          variants={staggerContainer}
          initial="hidden"
          animate={isInView ? "visible" : "hidden"}
          className="grid grid-cols-2 md:grid-cols-3 gap-4"
        >
          {images.map((image, index) => (
            <motion.div
              key={index}
              variants={fadeInUp}
              className="relative overflow-hidden rounded-2xl aspect-square group minimal-card"
            >
              <img 
                src={image} 
                alt={`Gallery ${index + 1}`}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

// Sponsors Section
